export default "__VITE_ASSET__B2Vtmq8C__"